import './App.css';
import 'leaflet/dist/leaflet.css';

import Layout from './pages/newLayout/Layout';

function App() {
  return <Layout/>;
}

export default App;
